module.exports = __webpack_public_path__ + "img/9788992026871.09259d61.jpg";